// Root mutations

export default {
  calls: state => {
    return state.calls
  },
  getActiveCalls: state => id => {
    if (!state.list) {
      return false
    }
    return _.filter(state.list, call => {
      return (
        (call.status === 'Travelling' ||
          call.status === 'Arrived' ||
          call.status === 'Arrival Completed' ||
          call.status === 'Departed') &&
        call.id !== id
      )
    })
  },
  hasActiveCall: (state, getters) => id => {
    if (!state.list) {
      return false
    }
    return getters.getActiveCalls(id).length > 0
  },
  getActiveCall: (state, getters) => {
    return getters.hasActiveCall() ? getters.getActiveCalls()[0] : {}
  },
  activeCallId: (state, getters) => {
    return getters.getActiveCall.id
  },
  getCallById: state => id => {
    const call = _.find(state.list, { id: parseInt(id) }) || {}
    return call
  },
  getSignature: (state, getters) => id => {
    const call = _.find(state.list, { id: parseInt(id) }) || {}
    if (call.id && call.signature) {
      return call.signature.data
    }
    return null
  },

  getMedia: (state, getters) => id => {
    const call = _.find(state.list, { id: parseInt(id) }) || {}
    if (call.id && call.media) {
      return call.media
    }
    return null
  },

  getSignatureByType: (state, getters) => (callId, type) => {
    const call = _.find(state.list, { id: parseInt(callId) }) || {}
    if (call.id && call.signature && call.signature[type]) {
      return call.signature[type].data
    }
    return null
  },
  hasPowra: state => {
    return state.hasPowra
  },

  currentRiskAssessment: state => {
    return state.currentRiskAssessment ? state.currentRiskAssessment : null
  },

  getHazards: state => {
    return state.currentRiskAssessment &&
      state.currentRiskAssessment.fields.hazards
      ? state.currentRiskAssessment.fields.hazards
      : []
  },

  getControls: state => {
    return state.currentRiskAssessment &&
      state.currentRiskAssessment.fields.controls
      ? state.currentRiskAssessment.fields.controls
      : []
  },

  getHazardControls: state => {
    return state.currentRiskAssessment &&
      state.currentRiskAssessment.fields.hazards_controls
      ? state.currentRiskAssessment.fields.hazards_controls
      : []
  },

  forms: state => {
    return state.forms
  },

  getFormSchemas: state => {
    return state.formSchemas
  },

  getFormData: state => {
    return state.formData
  },

  hasWorksheet: state => {
    let worksheet = _.find(state.completedCallForms, {
      slug: 'engineer-worksheet'
    })
    return worksheet ? true : false
  },

  getCompletedCallForms: state => {
    return state.completedCallForms
  },

  getSelectedFormId: state => {
    return state.selectedFormId
  }
}
